import { forwardRef } from "react";
import { topicStyle, STONE_TEXTURE } from "@/lib/theme";

/* Hidden 4:5 node captured by html2canvas for social sharing. */
const ShareableQuote = forwardRef(({ extract }, ref) => {
  if (!extract) return null;
  const ts = topicStyle(extract.topic);

  return (
    <div style={{ position: "fixed", left: "-9999px", top: 0 }} aria-hidden="true">
      <div
        ref={ref}
        style={{
          width: 1080,
          height: 1350,
          position: "relative",
          overflow: "hidden",
          backgroundColor: "#0c0a09",
          fontFamily: "'Manrope', sans-serif",
        }}
      >
        <img
          src={STONE_TEXTURE}
          crossOrigin="anonymous"
          alt=""
          style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: 0.5 }}
        />
        <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(12,10,9,0.82)" }} />

        <div
          style={{
            position: "absolute",
            inset: 0,
            padding: "110px 90px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              style={{
                display: "inline-block",
                border: `2px solid ${ts.color}`,
                color: ts.color,
                padding: "10px 22px",
                fontSize: 26,
                letterSpacing: "6px",
                fontWeight: 700,
              }}
            >
              {ts.label}
            </div>
          </div>

          <div style={{ borderLeft: `6px solid ${ts.color}`, paddingLeft: 44 }}>
            <p
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 74,
                lineHeight: 1.18,
                color: "#f5f5f4",
                margin: 0,
                fontWeight: 600,
              }}
            >
              {extract.quote}
            </p>
          </div>

          <div>
            <p style={{ fontSize: 34, color: "#f5f5f4", fontWeight: 700, margin: "0 0 8px 0" }}>
              {extract.author}
            </p>
            <p style={{ fontSize: 27, color: "#a8a29e", fontStyle: "italic", margin: 0 }}>
              {extract.book}
            </p>
            <div
              style={{
                marginTop: 46,
                paddingTop: 30,
                borderTop: "1px solid rgba(168,162,158,0.3)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 26, letterSpacing: "5px", color: ts.color, fontWeight: 600 }}>
                THE&nbsp;DAILY&nbsp;FORGE
              </span>
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 22, letterSpacing: "3px", color: "#78716c" }}>
                5&nbsp;EXTRACTS&nbsp;DAILY
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

ShareableQuote.displayName = "ShareableQuote";
export default ShareableQuote;
